import { Component, input, output } from '@angular/core';
import { CheckboxChangeEventDetail } from '@ionic/angular';
import { IonCheckboxCustomEvent } from '@ionic/core';
import { VehicleOption, VehicleSection, VehicleStep } from 'src/app/models/vehicleorder.model';

export interface StepCheckboxChangeEvent {
    event: IonCheckboxCustomEvent<CheckboxChangeEventDetail<unknown>>;
    step: VehicleStep;
    section: VehicleSection;
    option: VehicleOption;
}

@Component({
    selector: 'app-vehicle-config-step',
    templateUrl: './vehicle-config-step.component.html',
    styleUrls: ['./vehicle-config-step.component.scss'],
    standalone: false
})
export class VehicleConfigStepComponent {
    step = input.required<VehicleStep>();
    selectedPaint = input<VehicleOption | null>(null);
    isSelectedFn = input.required<(step: VehicleStep, section: VehicleSection, option: VehicleOption) => boolean>();
    isMobileLayout = input(false);

    paintSelected = output<VehicleOption>();
    checkboxChange = output<StepCheckboxChangeEvent>();

    onCheckboxChange(
        event: IonCheckboxCustomEvent<CheckboxChangeEventDetail<unknown>>,
        section: VehicleSection,
        option: VehicleOption
    ): void {
        this.checkboxChange.emit({ event, step: this.step(), section, option });
    }
}
